import { useReadOnly } from '../../Hooks/useReadOnly';
import { Permissions } from '../../Security/permissions';
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faPen, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import Table from '../../Components/Table/Table';
import SAPCompanyConfigModal from './SAPCompanyConfigModal';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import { SAPCompanyConfigDataService } from '../../Services/SAPCompanyConfigDataService';
import ConfirmationModal from '../../Components/ConfirmationModal/ConfirmationModal';

const SAPListContent = () => {
    const readOnly = useReadOnly(Permissions.DataManagement.SapConnection);
  const { instance, accounts, inProgress } = useMsal();
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);      // null = create
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    if (inProgress === 'none' && accounts.length > 0) load();
  }, [inProgress]);

  const token = async () => {
    const req = { ...loginRequest, account: accounts[0] };
    return (await instance.acquireTokenSilent(req)).accessToken;
  };

  const load = async () => {
    setRows(await SAPCompanyConfigDataService.getAllCompanyConfigs(await token()));
  };

  const handleSave = async dto => {
        if (readOnly) return;
    const t = await token();
    if (edit) await SAPCompanyConfigDataService.updateCompanyConfig(edit.companyId, dto, t);
    else      await SAPCompanyConfigDataService.createCompanyConfig(dto, t);
    setEdit(null); load();
  };

  const handleDelete = async () => {
        if (readOnly) { return; }
    await SAPCompanyConfigDataService.deleteCompanyConfig(deleteId, await token());
    setDeleteId(null); load();
  };

  const columns = React.useMemo(() => [
    { header: 'ID',        accessorKey: 'companyId' },
    { header: 'Company DB',accessorKey: 'companyDb' },
    { header: 'Base URL',  accessorKey: 'baseUrl' },
    { header: 'User',      accessorKey: 'userName' },
    {
      header: 'Actions',
      id: 'actions',
      cell: ({ row }) => (
        <div className='d-flex gap-2'>
          <Button disabled={readOnly} size='sm' variant='outline-secondary'
                  onClick={() => setEdit(row.original)}>
            <FontAwesomeIcon icon={faPen} />
          </Button>
          <Button disabled={readOnly} size='sm' variant='outline-danger'
                  onClick={() => setDeleteId(row.original.companyId)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      )
    }
  ], [readOnly]);

  return (
    <Container fluid className='h-100 d-flex flex-column'>
      <div className='d-flex justify-content-end mb-2'>
        <Button className='me-2' variant='outline-primary' onClick={load}>
          <FontAwesomeIcon icon={faRefresh}/>
        </Button>
        <Button disabled={readOnly} variant='primary' onClick={() => setEdit({})}>
          <FontAwesomeIcon icon={faPlus}/> New company
        </Button>
      </div>

      <Row><Col>
        <Table
          columns={columns}
          data={rows}
          tableClass='table-hover'
          containerClass='table-responsive'
          headerClass='table-light'
        />
      </Col></Row>

      { edit      !== null && <SAPCompanyConfigModal
                                show={true}
                                onHide={() => setEdit(null)}
                                onSave={handleSave}
                                initial={Object.keys(edit).length ? edit : null}/> }

          {deleteId !== null && (
              <ConfirmationModal
                  show={true}
                  title="Delete company configuration"
                  content="Are you sure you want to delete this company configuration?"
                  onHide={() => setDeleteId(null)}
                  onCancelClick={() => setDeleteId(null)}
                  onAcceptClick={handleDelete}
              />
          )}
    </Container>
  );
};

const SAPCompanyConfigListPage = () => (
  <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
    <PageLayout2 title='Company Configurations'>
      <SAPListContent />
    </PageLayout2>
  </MsalAuthenticationTemplate>
);

export default SAPCompanyConfigListPage;
